import { getSupabase } from '@/lib/supabase';

/**
 * Which of these ids exist (and are readable) in `exercises`. Backs GlobalStateProvider's
 * `getExercisesByIds`, used by src/lib/workouts/serialize.ts to keep valid ids on save.
 *
 * The rest of this adapter moved to the golden-slice data module (src/data/exercisesApi.ts)
 * in ARCH-7. This is the last direct-Supabase exercise read, so it should move to a Worker
 * endpoint too (see the ARCH-2 plan's slice notes).
 */
export async function fetchExercisesByIds(ids: string[]): Promise<Set<string>> {
  const sb = getSupabase();
  if (!sb) return new Set();
  const uniq = Array.from(new Set((ids || []).filter(Boolean)));
  if (!uniq.length) return new Set();
  const { data, error } = await sb.from('exercises').select('id').in('id', uniq);
  if (error) {
    try {
      console.warn('[exercises] fetchExercisesByIds failed', error);
    } catch {
      // OBS-11 a-ignore: dev-only debug logging must never break the real code path.
    }
    return new Set();
  }
  return new Set((data || []).map((r: any) => r.id));
}
